import api from './api';

const devKey = (type) => `boufi_device_id_${type}`;
const ckKey = (type) => `boufi_did_${type}`;

const ckGet = (k) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${k}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : null;
  } catch { return null; }
};
const ckSet = (k, v) => {
  try { document.cookie = `${k}=${encodeURIComponent(v)}; max-age=157680000; path=/; SameSite=Lax`; } catch { /* ignore */ }
};

export async function initAppareil(type, storageKey) {
  const locale = localStorage.getItem(storageKey) || ckGet(`boufi_bq_${type}`) || null;
  try {
    const id = localStorage.getItem(devKey(type)) || localStorage.getItem('boufi_device_id') || ckGet(ckKey(type));
    const { data } = await api.post('/appareils/register', { device_id: id, type, boutique_locale: locale });
    localStorage.setItem(devKey(type), data.device_id);
    ckSet(ckKey(type), data.device_id);
    if (data.statut === 'confirme' && data.boutique_id) {
      localStorage.setItem(`boufi_boutique_confirmee_${type}`, data.boutique_id);
      ckSet(`boufi_bq_${type}`, data.boutique_id);
      if (locale !== data.boutique_id) {
        localStorage.setItem(storageKey, data.boutique_id);
        window.location.reload();
      }
    }
    return { ...data, locale };
  } catch {
    const confirmee = localStorage.getItem(`boufi_boutique_confirmee_${type}`) || ckGet(`boufi_bq_${type}`);
    return { statut: confirmee || locale ? 'hors-ligne' : 'a_rattacher', boutique_id: confirmee || locale, locale };
  }
}

export function getDeviceId(type) {
  return localStorage.getItem(devKey(type)) || localStorage.getItem('boufi_device_id') || ckGet(ckKey(type));
}
